import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../../services/firebase';
import { parseErrorType } from '../../../utils';
import { ERROR_TYPES } from '../../../components/Modal/ErrorModal';
import { trackError } from '../../../utils';

export const useAnalysisError = () => {
  const handleAnalysisError = async (
    error, 
    historyItem, 
    userId, 
    showErrorModal, 
    startAnalysis,
    setProgressModal,
    setLoading,
    setCurrentAnalysisId
  ) => {
    console.error("Analysis error:", error);
    
    // 에러 발생 시 진행률 모달 즉시 닫기
    setProgressModal(prev => ({ ...prev, open: false }));
    
    // 에러 발생 시 상태를 'stopped'로 변경 (에러로 인한 중단)
    const docRef = doc(db, "users", userId, "history", historyItem.id);
    await updateDoc(docRef, { 
      status: 'stopped',
      stoppedReason: 'error',
      stoppedAt: serverTimestamp()
    });
    
    // 일반적인 에러 처리 (연결 끊김은 이미 위에서 처리됨)
    // 에러 타입 파싱
    let errorType = ERROR_TYPES.UNKNOWN_ERROR;
    let runningHistoryId = null;
    
    if (error.message && error.message.includes(':')) {
      const errorParts = error.message.split(':');
      errorType = errorParts[0];
      
      // 🔥 YOUTUBE_TIMEOUT 에러 특별 처리
      if (errorType === 'YOUTUBE_TIMEOUT') {
        console.log('⏰ [YouTube 타임아웃] 15초 초과로 인한 자막 추출 지연 감지');
        errorType = ERROR_TYPES.YOUTUBE_TIMEOUT;
      }
      // ANALYSIS_IN_PROGRESS 에러인 경우 히스토리 ID 추출
      else if (errorType === 'ANALYSIS_IN_PROGRESS' && errorParts.length >= 3) {
        runningHistoryId = errorParts[2];
        console.log('🔄 [분석 중복] 실행 중인 히스토리 ID:', runningHistoryId);
      }
    } else {
      errorType = parseErrorType(error.message || error);
    }
    
    // 에러 모달 표시
    showErrorModal(
      errorType, 
      '', 
      () => startAnalysis(historyItem),
      runningHistoryId || historyItem.id // 실행 중인 히스토리 ID 우선, 없으면 현재 히스토리 ID
    );
    
    // Google Analytics 에러 이벤트 추적
    trackError(errorType, error.message || 'Unknown error');
    
    // 상태 정리
    setLoading(false);
    setCurrentAnalysisId(null);
  };

  return {
    handleAnalysisError
  };
}; 